(function () {
  function init() {
    document.querySelectorAll('.spec-group__header').forEach(function (header) {
      header.addEventListener('click', function () {
        if (window.innerWidth >= 750) return;
        header.closest('.spec-group').classList.toggle('is-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
